import api from './api';
import { ResponseManagement, ResponseData } from '../@types/managementTypes';

const managementUrl = `/api/management/${process.env.REACT_APP_MANAGEMENT_RECORD_ID}/`;

function getManagementsDates() {
	return api.get<ResponseManagement>(managementUrl);
}

function updateManagementsDates(config: ResponseData) {
	return api.put<ResponseManagement>(managementUrl, config);
}

const managementServices = {
	getManagementsDates,
	updateManagementsDates,
};

export default managementServices;